import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { LayoutData } from "@ServerTypes/layoutView/layoutView.schema";

type CurrentSelectedSidebarCellState = string;
type ShowStickySidebarState = boolean | string;

const initialCurrentSelectedSidebarCellState: CurrentSelectedSidebarCellState = "";
const initialShowStickySidebarState = "" as ShowStickySidebarState;

const currentSelectedSidebarCellSlice = createSlice({
  name: "currentSelectedSidebarCell",
  initialState: initialCurrentSelectedSidebarCellState,
  reducers: {
    setSidebarSelectedCell: (
      _state: CurrentSelectedSidebarCellState,
      action: PayloadAction<CurrentSelectedSidebarCellState>,
    ) => action.payload,
  },
});

const showStickySidebarSlice = createSlice({
  name: "showStickySidebar",
  initialState: initialShowStickySidebarState,
  reducers: {
    setShowStickySidebar: (_state: ShowStickySidebarState, action: PayloadAction<ShowStickySidebarState>) =>
      action.payload,
  },
});

// The user's currently selected PROJECT_DASHBOARD layout/view doc. Shared so the sidebar
// (which owns the layout picker) and the dashboard's module list stay in sync when the user
// switches, edits, or creates a layout — without needing a refresh.
type SelectedProjectLayoutState = LayoutData | null;
// NB: the `as` is load-bearing — `const x: SelectedProjectLayoutState = null` narrows (via control-flow
// analysis) to the literal `null`, so createSlice would infer its state type as `null` and reject the
// reducer below. The assertion keeps the initializer typed as the full union (matches the sibling slices).
const initialSelectedProjectLayoutState = null as SelectedProjectLayoutState;

const selectedProjectLayoutSlice = createSlice({
  name: "selectedProjectLayout",
  initialState: initialSelectedProjectLayoutState,
  reducers: {
    setSelectedProjectLayout: (_state: SelectedProjectLayoutState, action: PayloadAction<SelectedProjectLayoutState>) =>
      action.payload,
  },
});

export const { setSidebarSelectedCell } = currentSelectedSidebarCellSlice.actions;
export const { setShowStickySidebar } = showStickySidebarSlice.actions;
export const { setSelectedProjectLayout } = selectedProjectLayoutSlice.actions;

export const currentSelectedSidebarCell = currentSelectedSidebarCellSlice.reducer;
export const showStickySidebar = showStickySidebarSlice.reducer;
export const selectedProjectLayout = selectedProjectLayoutSlice.reducer;

export default {
  currentSelectedSidebarCell: currentSelectedSidebarCellSlice.reducer,
  showStickySidebar: showStickySidebarSlice.reducer,
  selectedProjectLayout: selectedProjectLayoutSlice.reducer,
};
